export default __webpack_public_path__ + "static/media/istanbul.7f95c62b.png";